import { useState, useEffect } from "react";

function useResizeableContainer({ containerRef }) {
  const [containerSize, setContainerSize] = useState({ width: 0, height: 0 });

  // hook to maintain sizing for sub components within larger containers

  useEffect(() => {
    const handleResize = () => {
      const container = containerRef.current;
      if (container) {
        const { width, height } = container.getBoundingClientRect();

        setContainerSize({ width, height });
      }
    };

    handleResize();

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return { containerSize };
}

export default useResizeableContainer;
